import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import { EMPLOYEE_MY_DOWNLOAD_INCOME_TAX_WITHHOLDING } from 'src/constants/EndpointUrls';
import Button from 'jbc-front/components/Button';
import { SearchReactSelect } from 'src/components';
import PreviewPdfModalContainer from 'src/containers/PreviewPdfModalContainer';
import styles from './IncomeTaxWithholdingsDetail.scss';

const makeSelectList = withholdingSlips => {
  if (_.isEmpty(withholdingSlips)) return [];
  return _.map(withholdingSlips, item => ({
    label: moment(item.year).year(),
    value: item.id
  }));
};

class IncomeTaxWithholdingsDetail extends React.Component {
  constructor(props) {
    super(props);
    const { withholdingSlipId, withholdingSlips = [] } = this.props;

    this.state = {
      isPdfPreview: false,
      selectingId: withholdingSlipId || _.get(_.head(withholdingSlips), 'id'),
      withholdingSlips: makeSelectList(withholdingSlips)
    };
  }

  pdfUrl() {
    return `${EMPLOYEE_MY_DOWNLOAD_INCOME_TAX_WITHHOLDING}?year=${this.selectingYear()}`;
  }

  showPreview = () => {
    this.setState({
      ...this.state,
      isPdfPreview: true
    });
  };

  hidePreview = () => {
    this.setState({
      ...this.state,
      isPdfPreview: false
    });
  };

  changeSelectId = newId => {
    this.setState({
      ...this.state,
      selectingId: newId
    });
  };

  selectingYear = () =>
    _.get(
      _.find(this.state.withholdingSlips, item => parseInt(item.value, 10) === parseInt(this.state.selectingId, 10)),
      'label'
    );

  render() {
    if (_.isEmpty(this.state.withholdingSlips)) {
      return (
        <div className="l-wrap-xs u-pt100">
          <div className="l-box-message">
            <p className="m-title-sub u-pt0 u-ta-c">登録済みの源泉徴収票がありません</p>
            <p className="u-ta-c">ご不明な点は管理者までお問い合わせください</p>
          </div>
        </div>
      );
    }
    return (
      <div className="l-wrap-xl l-contents-wrap">
        <h1 className="m-title-main">源泉徴収票</h1>
        <div className={styles.wrap}>
          <p className={styles.text}>表示したい年を選んでください</p>
          <div className={styles.action}>
            <div className={styles.selectYear}>
              <SearchReactSelect
                options={this.state.withholdingSlips}
                onChange={selected => {
                  this.changeSelectId(selected.value);
                }}
                value={this.state.selectingId}
                size="large"
              />
            </div>
            <div className={styles.button}>
              <Button primary onClick={this.showPreview} className="u-mr15">
                源泉徴収票を表示
              </Button>
              <PreviewPdfModalContainer
                header="源泉徴収票"
                isOpen={this.state.isPdfPreview}
                hideModal={this.hidePreview}
                url={this.pdfUrl(this.state.retirementYear)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  startingYear: state.master.startingYear
}))(IncomeTaxWithholdingsDetail);
